<script>
  import utils from '@/utils'
  export default {
    data () {
      return {
        currentRoute: utils.getQueryString('domain')
      }
    },
    mounted () {
    },
    computed: {
      ViewComponent () {
        var hasView = false
        var dir = this.currentRoute
        try {
          require('@/page/' + dir + '/login.vue')
          hasView = true
        } catch (e) {
          // console.log(e, '文件不存在，请手动创建一个')
        }
        return hasView ? require('@/page/' + dir + '/login.vue') : require('@/page/byl/auth/login-page')
      }
    },
    render (h) {
      return h(this.ViewComponent.default)
    }
  }
</script>



// WEBPACK FOOTER //
// src/connects/pageLogin.vue